<!-- Address line -->
@if (installation.address && showAddress) {
    <span
        class="address-line flex flex-col body-copy whitespace-pre-line fg-petroleum"
        [ngClass]="{ 'small-font-size': smallSize }"
        >{{ formatAddress(installation.address) }}
    </span>
}

<!-- Details line: Installation / Aftagenr. / Måler -->
<div class="installation-meta body-small fg-petroleum" [ngClass]="{ 'small-font-size': smallSize }">
    <span class="info-pair">
        <span class="body-small font-bold">
            {{ 'userProfile.customerRelations.installationTitle' | translate }}
        </span>
        <span>{{ formatValueWithPeriod(installation?.installationNumber) }}</span>
    </span>
    <span class="info-pair">
        <span class="body-small font-bold">Aftagenr.:</span>
        <span>{{ formatValueWithPeriod(getMeteringPoint()) }}</span>
    </span>
    <span class="info-pair">
        <span class="body-small font-bold">
            {{ 'userProfile.customerRelations.meter' | translate }}
        </span>
        <span>{{ installation?.meterNumber || '-' }}</span>
        @if (isProductionInstallation) {
            <span class="ml-1" translate="userProfile.customerRelations.biogasProduction"></span>
        }
        @if (elVarmeProductionLabel) {
            <span class="ml-1" [translate]="elVarmeProductionLabel"></span>
        }
    </span>
</div>

<!-- Closed contract info -->
@if (installation.contract?.isClosed) {
    <strong
        class="flex flex-col whitespace-pre-line text-green"
        [ngClass]="{ 'small-font-size': smallSize }"
        translate="customerRelations.closedContract"
    >
    </strong>
}
